import * as Either from 'fp-ts/lib/Either';
import { identity, pipe } from 'fp-ts/lib/function';

export const getOrThrow = <E, A>(ma: Either.Either<E, A>): A =>
  pipe(
    ma,
    Either.fold((error) => {
      throw error;
    }, identity)
  );
